/**
 * Created by lenovo on 2017/2/14.
 */
import React, {
    Component,
    PropTypes
} from 'react';
import render from "react-dom";
import {
    Link
} from "react-router";
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
import ContentHeader from 'CONFIG/component/contentHeaderLeft'
import LongSearchInput from 'CONFIG/component/search/longSearchInput'
import ellaService from 'SERVICES/purifier/ella/ellaService'
import Tip from 'COMPONENT/tip'
import {language,pageOption} from 'UTIL/common'
import BoxHeader from "CONFIG/component/boxHeader"
import ModalDel from 'COMPONENT/ModalDel'

export default class SubsystemIndex extends Component {
    constructor(props) {
        super(props);
        this.search = this.search.bind(this);
        this.delList = this.delList;
        this.del = this.del.bind(this);
        this.handle = this.handle.bind(this);
        this.state = {
            list: [],
            pageSize: 10,
            page: 1,
            total: 0,
            delRow: {},
            detailList : {},
            menuId : sessionStorage.menuId,
        }
    };
    componentDidMount(){
        this.onPageChange(this.state.page,this.state.pageSize);
    }
    onPageChange(page, sizePerPage, e) {
        const arr = {
            "page": page,
            "pageSize": sizePerPage,
            "search":$.trim($("#search").val()),
        };
        var data = JSON.stringify(arr);
        ellaService.subsystemList({data}).then(body=>{
            const json = body.data.page;
            this.setState({
                total : json.total,
                list : json.records,
                page: page,
                pageSize: sizePerPage,
            })
        })
    }
    search(){
      this.onPageChange(1,this.state.pageSize);
    }
    handle(cell, row) {
        const edit_url = "/ella/permission/subsystemEdit/" + row.id;
        return <div>
            <Link to={edit_url}  className="btn btn-info btn-sm">{language()['edit']}</Link>&nbsp;&nbsp;
            <Link to={'/ella/permission/subsystemDetail/'+row.id}
                  className="btn btn-success btn-sm">{language()['view']}</Link>&nbsp;&nbsp;
            <a  className={row.number == "ella"?"hidden":"btn btn-danger btn-sm"}
                data-target="#delModal" data-toggle="modal"  onClick={this.delList.bind(this,row.id,row.name)}>{language()['delete']}</a>
        </div>;
    };
    delList(id, name, e) {
        const delList = {
            "id": id,
            "name": name
        };
        this.setState({
            delRow: delList,
        })
    }
    del() {
        var id = this.state.delRow.id;
        ellaService.subsystemDoDelete(id).then(body=>{
            this.onPageChange(1,this.state.pageSize);
            if (body.code == 8001) {
                $("#success_msg").text(body.msg);
                $("#success_tip").removeClass("hidden");
                $("#success_tip").focus();
                setTimeout(function() {
                    $("#success_tip").addClass("hidden");
                }, 3000);
            } else {
                $("#error_msg").text(body.msg);
                $("#error_tip").removeClass("hidden");
                $("#error_tip").focus();
                setTimeout(function() {
                    $("#error_tip").addClass("hidden");
                }, 3000);
            }
        })
    }
    reset(){
        $("#search").val('');
        this.onPageChange(1,10)
    }

    render() {
        const create_url = "/ella/permission/subsystemCreate";
        let options = pageOption(this.state.page,this.state.pageSize);
        options['onPageChange']=this.onPageChange.bind(this);
        return (
            <div >
                <ContentHeader nameLg="PermissionManagement" nameSm="Subsystem"/>
                <section className="content" >
                    <div className="box box-primary color-palette-box">
                        <BoxHeader name="add" title='SubsystemList' url={create_url}/>
                        <div className="box-body">
                            <Tip ids=""/>
                            <div className="title-box">
                                <div className="clearfix">
                                    <LongSearchInput id="search" name={language()['SubsystemName']+"/"+language()['SubsystemNumber']}/>
                                    <button type="button" className="btn btn-info" onClick={this.search.bind(this)}>{language()['query']}</button>
                                    &nbsp;&nbsp;<button type="button" className="btn btn-warning" id="reset" onClick={this.reset.bind(this)}>{language()['resetting']}</button>
                                </div>
                            </div>
                            <BootstrapTable data = {this.state.list} fetchInfo={{ dataTotalSize: this.state.total }} striped hover pagination={true} options={options}  >
                                <TableHeaderColumn isKey={true} dataField='id' hidden={true}>id</TableHeaderColumn>
                                <TableHeaderColumn dataField='name' width="200">{language()['SubsystemName']}</TableHeaderColumn>
                                <TableHeaderColumn dataField='number' width="200">{language()['SubsystemNumber']}</TableHeaderColumn>
                                <TableHeaderColumn  dataField='url' width="250" >{language()['AccessPath']}</TableHeaderColumn>
                                <TableHeaderColumn  dataFormat={this.handle} width="180" columnClassName="td-mid">{language()['operation']}</TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </section>
                <ModalDel delModSure={this.del} id="delModal"/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./modules/ella/permission/subsystem/subsystem.js